import { render } from "./SliderDescriptionsMobile.vue?vue&type=template&id=384fad4e&scoped=true"
import script from "./SliderDescriptionsMobile.vue?vue&type=script&lang=js"
export * from "./SliderDescriptionsMobile.vue?vue&type=script&lang=js"

import "./SliderDescriptionsMobile.vue?vue&type=style&index=0&id=384fad4e&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384fad4e"]])

export default __exports__